export const MAX_LICENSES_ACCOUNT = 32000;
